export const landingTour = [
  { target: '.tour-gallery-nav', content: 'Here you can see all the images you have generated or uploaded.' },
  { target: '.tour-products-nav', content: 'Here you can see the list of our products.' },
  { target: '.tour-mockups-nav', content: 'Here you can see your generated mockups ready to be ordered or re-ordered.' },
  { target: '.tour-orders-nav', content: 'Here you can manage and check your orders.' },
];